<template>
    <b-container fluid>
        <div>
            <b-tabs content-class="mt-3">
                <b-tab title="Formulario" active>
                    <b-row>
                        <b-col cols="12" class="py-2">
                            <label for="type">Tipo</label>
                            <b-form-select
                                size="sm"
                                :options="types"
                                id="type"
                                v-model="ticket.type"
                                @change="$v.ticket.type.$touch()"
                                :valid="!$v.ticket.type.$error"
                                disabled
                            ></b-form-select>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="title">Titulo</label>
                            <b-form-input
                                type="text"
                                size="sm"
                                id="titleFinalized"
                                v-model="ticket.title"
                                @input="$v.ticket.title.$touch()"
                                :valid="!$v.ticket.title.$error"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col cols="12" class="py-2">
                            <label for="description">Descripción</label>
                            <small
                                >En caso de Error describa paso a paso como
                                surgió y como se puede reproducir</small
                            >
                            <b-form-textarea
                                v-model="ticket.description"
                                disabled
                            ></b-form-textarea>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="reporter"
                                >Usuario que tiene el problema</label
                            >
                            <app-form-select-input
                                :options="users"
                                v-model="ticket.reporter"
                                disabled
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="reporter">Para algun cliente?</label>
                            <app-form-select-input
                                :options="clients"
                                v-model="ticket.clientProblem"
                                disabled
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="module">Módulo de Bitacorapp</label>
                            <app-form-select-input
                                :options="modules"
                                v-model="ticket.moduleId"
                                @change="$v.ticket.moduleId.$touch()"
                                :valid="!$v.ticket.moduleId.$error"
                                disabled
                            >
                            </app-form-select-input>
                        </b-col>
                        <b-col cols="12" md="6" class="py-2">
                            <label for="device">Dispositivo</label>
                            <b-form-select
                                size="sm"
                                :options="devices"
                                v-model="ticket.device"
                                disabled
                            ></b-form-select>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Archivos">
                    <b-container fluid class="p-4">
                        <div v-if="photos.length">
                            <b-row>
                                <b-col v-for="p in photos" :key="p.id">
                                    <b-link
                                        width="120"
                                        height="120"
                                        :href="p.file_url"
                                        target="_blank"
                                        >{{ p.name }}</b-link
                                    >
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                            <p>no hay imagenes</p>
                        </div>
                    </b-container>
                </b-tab>
                <b-tab title="Notas">
                    <b-row>
                        <b-col>
                            <b-row
                                class="mb-2"
                                v-for="(note, i) in ticket.ticketNotes"
                                :key="note.id"
                                :class="{ even: i % 2 === 0, odd: i % 2 !== 0 }"
                            >
                                <b-col v-if="userNote">{{ note.name }}</b-col>
                                <b-col v-else>{{ note.user.name }}</b-col>
                                <b-col cols="6">{{ note.note }}</b-col>
                                <b-col>{{ note.created_at | datetime }}</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </div>
    </b-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    data: () => ({
        ticket: {
            id: '',
            title: '',
            description: '',
            reporter: '',
            clientProblem: '',
            device: '',
            moduleId: '',
            type: '',
            globalId: 0,
            ticketNotes: [],
        },
        note: '',
        flagNoteSupport: false,
        images: [],
        users: [],
        clients: [],
        modules: [],
        photos: [],
        types,
        devices,
        userNote: false,
    }),
    validations: {
        ticket: {
            type: { required },
            title: { required },
            description: { required },
            moduleId: { required },
        },
    },
    methods: {
        fill(ticket) {
            this.ticket.type = ticket.error_type
            this.ticket.title = ticket.title
            this.ticket.description = ticket.description
            this.ticket.reporter = ticket.reporter.id
            !!ticket.client && (this.ticket.clientProblem = ticket.client.id)
            this.ticket.moduleId = ticket.module.id
            this.photos = ticket.ticket_files
            this.globalId = ticket.id
            this.ticket.device = !!ticket.device ? ticket.device : ''
            this.ticket.id = ticket.id
            this.ticket.ticketNotes = ticket.ticket_notes
        },
        async loadModules() {
            const { data } = await repo.get(
                'security/modules',
                null,
                'Lo sentimos, ha ocurrido un error'
            )
            this.modules = data
        },
        async loadUsers() {
            const { data } = await repo.get('users', { clientSide: false })
            this.users = data
        },
        async loadClients() {
            const { data } = await repo.get('clients')
            this.clients = data
        },
        reset() {
            Object.keys(this.ticket).map(key => (this.ticket[key] = ''))
            this.photos = []
            this.images = []
        },
    },
    mounted() {
        this.loadModules()
        this.loadUsers()
        this.loadClients()
    },
}

const types = [
    {
        value: 'error',
        text: 'Error',
    },
    {
        value: 'solicitud',
        text: 'Solicitud',
    },
    {
        value: 'sugerencia',
        text: 'Sugerencia',
    },
]

const devices = [
    {
        value: 'pc',
        text: 'Computador',
    },
    {
        value: 'tablet',
        text: 'Tablet',
    },
    {
        value: 'celular',
        text: 'Celular',
    },
    {
        value: 'todos',
        text: 'Todos',
    },
]
</script>
